import React, { useState } from "react";
import { MDBBtn, MDBCol, MDBRow, MDBIcon } from "mdbreact";
import { useDispatch, useSelector } from "react-redux";
import {
  PatchAuth,
  UPDATE_INFO,
  UPLOAD,
} from "../../../../../services/redux/slices/assets/persons/auth";
import LabRequest from "./stepper/step1";
import CardRequest from "./stepper/step2";
import Schedule from "./stepper/step4";
import ValidID from "./stepper/step3";

import "./style.css";
import { SAVE } from "../../../../../services/redux/slices/commerce/pos/services/onBoardings";
import Spinner from "../../../../../components/spinner";
import Swal from "sweetalert2";
import { Cloudinary } from "../../../../../services/utilities";

const steps = [
  {
    id: 1,
    label: "Request Form",
    component: LabRequest,
  },
  {
    id: 2,
    label: "Card",
    component: CardRequest,
  },
  {
    id: 3,
    label: "Valid ID",
    component: ValidID,
  },

  {
    id: 4,
    label: "Schedule",
    component: Schedule,
  },
];

const _form = {
  form: "",
  branch: "",
  haveCard: null,
  card: {
    id: "",
    expiry: "",
    img: {
      back: "",
      front: "",
    },
    type: "",
    primary: true,
    proof: "",
  },
  vi: {
    img: {
      back: "",
      front: "",
    },
    expiry: "",
    type: "",
    id: "",
  },
  schedule: new Date().toISOString().split("T")[0],
};

const CustomStepper = () => {
  const { auth, token } = useSelector(({ auth }) => auth),
    [form, setForm] = useState(_form),
    [activeStep, setActiveStep] = useState(1),
    [valid, setValid] = useState({ 1: true, 2: true, 3: true }), //form,card,schedule
    dispatch = useDispatch();

  const prevStep = () => {
    if (activeStep === 4 && !form.haveCard) return setActiveStep(2);
    const _activeStep = activeStep > 1 ? activeStep - 1 : 1;
    setActiveStep(_activeStep);
  };

  const isLastStep = activeStep === steps.length;

  const CurrentComponent = steps.find((s) => s.id === activeStep)?.component;

  const handleNext = (e) => {
    e.preventDefault();

    const isStep1 = activeStep === 1;
    const isStep2 = activeStep === 2;
    const isStep3 = activeStep === 3;
    const isStep4 = activeStep === 4;

    if (isStep1) {
      const isValid = !!form.form;
      setValid((v) => ({ ...v, 1: isValid }));
      setForm((prev) => ({ ...prev, haveCard: null }));
      if (isValid) setActiveStep(2);
    }

    if (isStep2) {
      const { card } = form;
      const { img } = card;
      if (!form.haveCard) {
        return setActiveStep(4);
      }
      const isValid = !!img.front && !!img.back;
      setValid((v) => ({ ...v, 2: isValid }));
      if (isValid) setActiveStep(3);
    }

    if (isStep3) {
      const { vi } = form;
      const { img } = vi;
      const isValid = !!img.front && !!img.back;
      setValid((v) => ({ ...v, 3: isValid }));
      if (isValid) setActiveStep(4);
    }

    if (isStep4) {
      const isValid = form.schedule.branch && form.schedule.date;
      setValid((v) => ({ ...v, 3: !!isValid }));
      // You can trigger submit here if needed
    }
  };
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const portfolioPath = `users/${auth.email}/portfolio`;
    const { card, vi, haveCard = false, form: formImage, schedule } = form;

    // base data
    const data = {
      vendor: form.branch,
      pid: auth._id,
      haveCard: haveCard ?? false,
      schedule,
      requirements: {
        ...(haveCard && { hmo: card.type }),
      },
    };

    // clone for update
    let healthCard = {
      ...card,
      isPrimary: card.primary,
    };
    let validID = {
      ...vi,
    };

    // upload helper
    const upload = async (path, base64, name) => {
      if (!base64) {
        console.warn("⚠️ No file to upload:", { path, name });
        return null;
      }
      const buildForm = Cloudinary.buildFileForm(base64, path, name);
      const res = await dispatch(UPLOAD({ data: buildForm, token })).unwrap();
      console.log("✅ Uploaded:", { path, name, imgId: res.imgId });
      return res.imgId;
    };

    try {
      // collect uploads
      const uploadTasks = [
        upload(
          `users/${auth.email}/booking`,
          formImage,
          `form-${schedule}` // unique filename
        ),
      ];

      if (haveCard) {
        uploadTasks.push(
          upload(`${portfolioPath}/${card.type}`, card?.img?.front, "front"),
          upload(`${portfolioPath}/${card.type}`, card?.img?.back, "back"),
          upload(`${portfolioPath}/${vi.type}`, vi?.img?.front, "front"),
          upload(`${portfolioPath}/${vi.type}`, vi?.img?.back, "back")
        );
      }

      // wait for all uploads
      const [rfId, cardFront, cardBack, viFront, viBack] = await Promise.all(
        uploadTasks
      );

      // attach uploaded IDs
      if (rfId) {
        data.requirements.rfId = rfId;
      }

      if (haveCard) {
        healthCard = {
          ...healthCard,
          img: { front: cardFront, back: cardBack },
        };

        validID = {
          ...validID,
          img: { front: viFront, back: viBack },
        };
        await dispatch(
          UPDATE_INFO({
            token,
            data: { _id: auth._id, healthCard, validID },
          })
        ).unwrap();
      }

      // save booking data
      await dispatch(SAVE({ token, data })).unwrap();

      // update user info

      // success alert
      Swal.fire({
        icon: "success",
        title: "Schedule Submitted!",
        html: `
        <p style="margin-top: 8px;">
          Your schedule has been submitted for approval.
        </p>
        <p style="margin: 4px 0;">
          You’ll receive a text once it's confirmed, or you can check the system for updates.
        </p>
      `,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Got it!",
      });

      // reset form
      setForm(_form);
      setActiveStep(1);
    } catch (error) {
      console.error("❌ Failed:", error);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: error?.message || "Something went wrong. Please try again.",
      });
    } finally {
      // persist updated auth locally
      if (haveCard) {
        dispatch(PatchAuth({ healthCard, validID }));
      }

      setIsLoading(false);
    }
  };

  const fakeDB = localStorage.getItem("patronCompany");
  const { hmo = [], branches = [] } = fakeDB ? JSON.parse(fakeDB) : {};

  return (
    <form onSubmit={isLastStep ? handleSubmit : handleNext}>
      <div className="stepper-wrapper ">
        <div className="d-flex justify-content-center mb-4">
          <div
            className="position-relative d-flex justify-content-between"
            style={{ width: "95%" }}
          >
            <div className="stepper-line">
              <div
                className="stepper-line-fill bg-primary"
                style={{
                  width: `${activeStep === 1 ? 0 : (activeStep - 1) * 33}%`,
                }}
              ></div>
            </div>

            {steps.map((step) => (
              <div key={step.id}>
                <div
                  className={`step ${
                    activeStep >= step.id ? "active" : ""
                  } position-relative`}
                >
                  <div className="step-circle">
                    {step.id === 4 ? (
                      <MDBIcon far icon="calendar-check" />
                    ) : (
                      step.id
                    )}
                  </div>
                  <div
                    className="step-label position-absolute"
                    style={{
                      bottom: "-15px",
                      width: "100px",
                      left: step.id === 1 ? "52%" : "50%",
                      transform: `translateX(-${step.id === 1 ? "48" : "50"}%)`,
                    }}
                  >
                    {step.label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="step-content">
          {CurrentComponent && (
            <CurrentComponent
              branches={branches}
              hmo={hmo}
              isValid={valid[activeStep]}
              setForm={setForm}
              form={form}
              setIsValid={(isValid) =>
                setValid((v) => ({ ...v, [activeStep]: isValid }))
              }
              setActiveStep={setActiveStep}
            />
          )}
        </div>

        <div className="stepper-buttons">
          <MDBRow className="mt-3">
            <MDBCol md="12" className="text-right">
              {activeStep > 1 && (
                <MDBBtn onClick={prevStep} rounded color="white" flat>
                  Back
                </MDBBtn>
              )}
              <MDBBtn
                color="primary"
                rounded
                type="submit"
                disabled={isLoading}
              >
                {isLastStep ? "Submit" : "Next"}{" "}
                <Spinner formSubmitted={isLoading} />
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </div>
      </div>
    </form>
  );
};

export default CustomStepper;
